function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
import React, { useCallback, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
const EmployeeComments = _ref => {
  let {
    selectedProject
  } = _ref;
  const [employeeComments, setEmployeeComments] = useState('');
  const saveEmployeeComment = useErrorHandling(useCallback(async event => {
    await generalRouteSubRouteService.update(selectedProject.claim_group_id, 'claim_groups', 'claim_project_reports', selectedProject.id, _objectSpread(_objectSpread({}, selectedProject), {}, {
      employee_comments: event.target.value
    }));
  }, [selectedProject]));
  const getEmployeeComment = useErrorHandling(useCallback(async () => {
    const response = await generalRouteSubRouteService.get(selectedProject.claim_group_id, 'claim_groups', 'claim_project_reports', selectedProject.id);
    setEmployeeComments(response.employee_comments);
  }, [selectedProject]));
  useEffect(() => {
    getEmployeeComment();
  }, [getEmployeeComment]);
  return /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    rows: 3,
    value: employeeComments,
    onChange: e => setEmployeeComments(e.target.value),
    onBlur: saveEmployeeComment
  });
};
export default EmployeeComments;